<!-- <template>
  <div>
    <div>
      <div v-for="(item, index) in userList" :key="index + ''">
        第{{ index + 1 }}组
        <div v-for="(item2, index2) in item" :key="index2 + 'd'"  style="display: inline-block; margin: 15px;">
          <el-radio v-model="FormData1['i'+index]" :label="item2.id">{{ item2.realName }}</el-radio>
        </div>
      </div>
      <el-button @click="setValues()">提交</el-button>
    </div>
  </div>
</template>
 <script>
export default {
  created() {
    this.setGroupsLeader();
  },
  data() {
    return {
      FormData1: {},
      userList: [],
    };
  },
  methods: {
    setGroupsLeader() {
      let datas = [
	[
		{
			"realName": "null_009262",
			"id": 7813
		},
		{
			"realName": "2736663918@qq.com",
			"id": 7440
		},
		{
			"realName": "2783095037@qq.com",
			"id": 7435
		},
		{
			"realName": "17702761991@qq.com",
			"id": 7421
		},
		{
			"realName": "1927383317@qq.com",
			"id": 7431
		}
	],
	[
		{
			"realName": "chenlza@yonyou.com",
			"id": 7423
		},
		{
			"realName": "17900009999@qq.com",
			"id": 7411
		},
		{
			"realName": "1132849046@qq.com",
			"id": 7495
		},
		{
			"realName": "17702761996@guo.com",
			"id": 7422
		},
		{
			"realName": "1036322011@qq.com",
			"id": 8290
		}
	],
	[
		{
			"realName": "1651923470@qq.com",
			"id": 7430
		},
		{
			"realName": "5@qq.com",
			"id": 7416
		},
		{
			"realName": "HEP",
			"id": 1035
		},
		{
			"realName": "3369047525@qq.com",
			"id": 7471
		},
		{
			"realName": "duxu@263.net",
			"id": 7785
		}
	],
	[
		{
			"realName": "1079976360@qq.com",
			"id": 7539
		},
		{
			"realName": "17702761994@qq.com",
			"id": 7419
		},
		{
			"realName": "903949@qq.com",
			"id": 7425
		},
		{
			"realName": "174663536@qq.com",
			"id": 7426
		},
		{
			"realName": "4357242@qq.com",
			"id": 7429
		}
	],
	[
		{
			"realName": "10511_2022214641",
			"id": 8972
		},
		{
			"realName": "17702761995@guo.com",
			"id": 7420
		},
		{
			"realName": "2@2.com",
			"id": 7464
		},
		{
			"realName": "1971655416@qq.com",
			"id": 7503
		},
		{
			"realName": "17702761986@qq.com",
			"id": 7415
		}
	],
	[
		{
			"realName": "1449620329@qq.com",
			"id": 7470
		}
	]
]
      this.userList = datas;
      for (let index = 0; index < datas.length; index++) {
        for (let index2 = 0; index2 < datas[index].length; index2++) {
          let element = datas[index][index2];
          if (index2 === 0) {
            this.$set(this.FormData1, ('i'+index), element.id); 
          }
        }
      }
	  let config = { headers: { "Content-Type": "multipart/form-data" } };    
	  config.Authorization=  "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMzgwMTI3MzEyMiIsImNyZWF0ZWQiOjE2ODgzNTQzMDcxNDIsImV4cCI6MTY4ODk1OTEwN30.Ot_7h_h3mptMNdZfC84c7Eg3jE-iP0d_UcoFqO5kVybPMmYUnLIXqbINsHkSxANX6tAWDdHmNLnzVtpAI0x_oQ"

	  this.axios.post("http://192.168.2.61:8080/XGroupsTask/addGroups?openClass=1415&userId=7813,7423",config)
         .then(resp => { 
                console.log(resp)
                            })

    },
    setValues(){
      console.log('提交id集合',JSON.stringify(this.FormData1))
    }
  },
};
</script>
 <style>
</style> -->


<template>

  <div class="chatAppBody">
        <!-- <div class="chatTitle">标题</div> -->
        <div class="chatBox">
            <div class="chatRow">
                <el-avatar class="chatAvatar" :size="30" src="	https://img-blog.csdnimg.cn/img_convert/77ea74568ab5a1bd8ab0c9dc67a1a972.png
"></el-avatar>
                <div class="chatMsgContent">
                    <div class="chatUsername">唯一客服系统</div>
                    <div class="chatContent">有什么可以帮您?</div>
                </div>
            </div>
            <div class="chatRow chatRowMe">
                <div class="chatContent">你好，这个客服系统多少钱？</div>
            </div>
        </div>
        <div class="chatBottom">输入框区域</div>
    </div>
</template>

<script>
export default {
	name: 'ChatApp',
        data() {
          return {
          }
        },
        methods: {
        },
  
}
</script>

<style>
.chatAppBody{
	    width: 80%;
		margin: auto;
        display: flex;
		overflow: auto;
        flex-direction: column;
        height: 662px;
        background-color: #f1f5f8;
    }
    .chatTitle{
        background: #fff;
    }
    .chatBox{
        flex: 1;
        padding: 0 5px;
    }
    .chatBottom{
        background: #fff;
    }
    .chatRow{
        display: flex;
        align-items: flex-end;
        margin: 5px 0px;
    }
    .chatAvatar{
        margin-right: 5px;
        flex-shrink: 0;
    }
    .chatUsername {
        font-size: 12px;
        white-space: nowrap;
        color: #999;
        margin-bottom: 2px;
    }
    .chatContent{
        border-radius: 10px 10px 10px 0px;
        padding: 10px;
        background-color: rgb(255,255,255);
        box-shadow: 0 5px 30px rgb(50 50 93 / 8%), 0 1px 3px rgb(0 0 0 / 5%);
        font-size: 14px;
        word-break: break-all;
        line-height: 21px;
    }
    .chatRowMe{
        justify-content: flex-end;
    }
    .chatRowMe .chatContent{
        border-radius: 10px 10px 0px 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/study/study3/student4/file.vue